import type { FC } from 'react';

import useTypeTracking from '../../analytics';
import { ShowProfileModalButton } from './components/ShowProfileModalButton';
import { SETTINGS_BUTTON_TYPE } from './hooks/useProfileAnalytics';
import { CurrentUserProvider, useCurrentUserContext } from './context/CurrentUserProvider';
import {
    ViewType,
    UserProfileViewProvider,
    useUserProfileViewContext,
} from './context/UserProfileViewProvider';
import EditView from './components/EditView';
import ReadView from './components/ReadView';

type UserProfileProps = {
    modalView?: boolean;
};

const UserProfileWithProviders: FC<UserProfileProps> = ({ modalView = false }) => {
    return (
        <CurrentUserProvider>
            <UserProfileViewProvider modalView={modalView}>
                <UserProfile />
            </UserProfileViewProvider>
        </CurrentUserProvider>
    );
};

const UserProfile = () => {
    const { user, isLoading, error } = useCurrentUserContext();
    const { viewType } = useUserProfileViewContext();

    const { Track } = useTypeTracking({
        data: {
            buttonType: SETTINGS_BUTTON_TYPE,
        },
    });

    if (isLoading || error || !user) {
        return null;
    }

    return <Track>{viewType === ViewType.EDIT ? <EditView /> : <ReadView />}</Track>;
};

export { ShowProfileModalButton };

export default UserProfileWithProviders;
